import { ReactNode } from "react";
import BaseButton from "./BaseButton";
import DefaultLoading from "../DefaultLoading";

function LoadingButton({
  isLoading,
  children,
}: {
  isLoading: boolean;
  children: ReactNode;
}) {
  return isLoading ? <DefaultLoading /> : <BaseButton>{children}</BaseButton>;
}

export default LoadingButton;
